// eslint-disable-next-line max-len
export const SYNCFUSION_LICENSE = 'ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hT35SdEViX31YcXxdRWBbWkZ+';
